import { AssetReference } from '@domain/creativeset/element-asset';
import { ElementKind } from '@domain/elements';
import { FeededReference } from '@domain/feed';
import { getFileExtension, getFileLocation, getFileName, removeFileExtension } from './url';
export function getAssetReferenceTypeOfElement(element) {
    switch (element.type) {
        case ElementKind.Image:
            return AssetReference.Image;
        case ElementKind.Video:
            return AssetReference.Video;
        case ElementKind.Widget:
            return AssetReference.Widget;
    }
    throw new Error(`Can't get asset reference name from an element that does not have any assets.`);
}
export function getFeedReferenceTypeOfElement(element) {
    switch (element.type) {
        case ElementKind.Image:
            return FeededReference.Image;
        case ElementKind.Video:
            return FeededReference.Video;
    }
    throw new Error(`Can't get feed reference name from an element that does not have any assets.`);
}
export function remapCreativeAssetUrls(url, destination) {
    try {
        const assetDomain = new URL(url).origin;
        const originalFileName = url.substring(url.lastIndexOf('/') + 1);
        return `${assetDomain}/${destination}/${originalFileName}`;
    }
    catch (e) {
        console.error(`Failed to remap url: ${e}`);
    }
}
export function addChecksumToAssetUrl(url, checksum) {
    const extension = getFileExtension(url);
    const fileName = removeFileExtension(getFileName(url));
    const fileLocation = getFileLocation(url);
    return `${fileLocation}/${fileName}_${checksum}.${extension}`;
}
export function updateVideoUrlToManifestUrl(url) {
    const fileName = removeFileExtension(getFileName(url));
    const fileLocation = getFileLocation(url);
    return `${fileLocation}/${fileName}/dash/manifest.mpd`;
}
